import { SignUpContainer } from 'common/components/Layout/AuthLayout/SignUpLayout'
import Head from 'next/head'
import { SignUpComponent } from 'services/auth/sign-up/SignUpComponent'
import { AuthLayout } from '../common/components/Layout/AuthLayout/AuthLayout'

const SignUp = () => (
  <SignUpContainer>
    <Head>
      <title>Sign Up | Seaplify</title>
    </Head>
    <AuthLayout>
      <SignUpComponent />
    </AuthLayout>
  </SignUpContainer>
)

SignUp.getLayout = (page: React.ReactNode | React.ReactNode[]) => page
export default SignUp
